import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import EntityForm from "../../../../helpers/EntityForm";
import Checkbox from "@mui/material/Checkbox";

const ContactForm = ({
  contact,
  longDescription,
}) => {
  const [useSessionInfo, setUseSessionInfo] = useState(true);

  const handleUseSessionInfoChecked = (event) => {
    setUseSessionInfo(event.target.checked);
  };

  const showUserDetails = contact || !useSessionInfo;

  return (
    <EntityForm isCreate={contact === null}>
      <input name="contactEntityId" readOnly hidden
             value={contact?.contactEntityId}/>
      <input name="useSessionInfo" readOnly hidden
             value={(contact === null && useSessionInfo).toString()}/>
      <input name="oldLongDescription" readOnly hidden
             value={encodeURIComponent(longDescription)}
      />
      <FormControl component="fieldset">
        {contact === null && <FormControlLabel
          control={
            <Checkbox
              id="useSessionInfo"
              name="useSessionInfo"
              checked={useSessionInfo}
              onChange={handleUseSessionInfoChecked}
            />
          }
          label={
            <Typography variant="body1">
              Use logged-in user info
            </Typography>
          }
        />}
      </FormControl>
      <TextField
        label="Request"
        type="text"
        id="request"
        name="request"
        required
        defaultValue={contact?.request}
        variant="outlined"
      />
      <TextField
        label="Description"
        type="text"
        id="longDescription"
        name="longDescription"
        margin="normal"
        multiline={true}
        defaultValue={longDescription}
        minRows={6}
        variant="outlined"
      />
      <TextField
        label="Status"
        type="text"
        id="status"
        name="status"
        required
        defaultValue={contact?.status}
        variant="outlined"
      />
      {showUserDetails && (
        <>
          <TextField
            label="First Name"
            type="text"
            id="firstName"
            name="firstName"
            required
            defaultValue={contact?.firstName}
            variant="outlined"
          />
          <TextField
            label="Last Name"
            type="text"
            id="lastName"
            name="lastName"
            required
            defaultValue={contact?.lastName}
            variant="outlined"
          />
          <TextField
            label="Email"
            type="email"
            id="email"
            name="email"
            required
            defaultValue={contact?.email}
            variant="outlined"
          />
          <TextField
            label="Phone Number"
            type="text"
            id="phone"
            name="phone"
            required={false}
            defaultValue={contact?.phone}
            variant="outlined"
          />
        </>)}
    </EntityForm>
  );
};

export default ContactForm;